import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(Draggable, InertiaPlugin, ScrollTrigger, ScrollToPlugin);

const communityModule = {
  scrollTriggerInstance: null,

  init: function() {
    setTimeout(() => {
      communityModule.initScrollTrigger();
      communityModule.setupResizeListener();
      communityModule.waitForElement();
      communityModule.initSmoothScroll();
    }, 1000);
  },

  initScrollTrigger: function() {
    const shareCommunityCntr = document.querySelector('.share-community-cntr.--desktop');

    if (shareCommunityCntr && window.innerWidth > 1250) {
      this.scrollTriggerInstance = ScrollTrigger.create({
        trigger: '.post-main-cntr',
        start: 'top 7%',
        end: 'bottom 80%',
        endTrigger: '.post-main-cntr',
        pin: shareCommunityCntr,
        pinSpacing: false,
        //    markers: true,
      });
    }
  },

  destroyScrollTrigger: function() {
    if (this.scrollTriggerInstance) {
      this.scrollTriggerInstance.kill();
      this.scrollTriggerInstance = null;
    }
  },

  setupResizeListener: function() {
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1250 && !this.scrollTriggerInstance) {
        this.initScrollTrigger();
        ScrollTrigger.refresh();
      } else if (window.innerWidth <= 1250 && this.scrollTriggerInstance) {
        this.destroyScrollTrigger();
      }
    });
  },
  getC7Product: function() {
    // Check if productSlugsModule is defined in the global scope
    if (typeof window.productSlugsModule === 'undefined') {
      return;
    }

    console.log(window.productSlugsModule);

    // Fetch data for each product slug
    window.productSlugsModule.forEach((slug) => {
      fetch(`https://api.commerce7.com/v1/product/slug/${slug}/for-web`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          tenant: 'rombauer-vineyards',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // Select all matching .c7-buy-product elements
          const productElements = document.querySelectorAll(`.shop-prdt-listing__item[data-product-slug="${data.slug}"]`);
          productElements.forEach((productElement) => {
            // Insert image element
            const figureEl = `
                <figure>
                    <a href="/product/${data.slug}">
                        <picture><img src="${data.images[1].src}" alt="${data.title}"></picture>
                    </a> 
            
                </figure>
            `;
            const figureContainerElement = productElement.querySelector('.fig-cntr');
            if (figureContainerElement) {
              figureContainerElement.insertAdjacentHTML('afterbegin', figureEl);
            }
            // rmbr btn btn--with-arrow

            // Insert title element
            const titleEl = `
                <a href="/product/${data.slug}">${data.title}</a>
            `;
            const titleContainerElement = productElement.querySelector('.title-cntr');
            if (titleContainerElement) {
              titleContainerElement.insertAdjacentHTML('afterbegin', titleEl);
            }

            setTimeout(function() {
              const btnElements = document.querySelectorAll('.c7-btn.c7-btn--primary');
              document.querySelectorAll('.c7-btn.c7-btn--primary');
              btnElements.forEach((btnElement) => {
                btnElement.classList.add('rmbr', 'btn', 'btn--with-arrow');
              });
            }, 1500);
          });
        });
    });
  },
  waitForElement: function(slug, tries = 20) {
    let attempts = 0;

    const interval = setInterval(() => {
      attempts++;

      const productElement = document.querySelector(`.c7-buy-product`);

      if (productElement || attempts === tries) {
        clearInterval(interval);

        if (productElement) {
          // Run your getC7Product function here
          communityModule.getC7Product();
        } else {
          console.error(`.c7-buy-product not found after ${tries} attempts.`);
        }
      }
    }, 100);
  },

  initSmoothScroll: function() {
    const links = document.querySelectorAll('.in-this-article a');

    links.forEach((link) => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          gsap.to(window, {
            scrollTo: {
              y: targetElement,
              offsetY: 60,
            },
            duration: 0.75,
            ease: 'power2.inOut',
          });
        }
      });
    });
  },
};

export default communityModule;
